/*eslint-env browser*/

function cssInjector (stylesOrParams) {

    if ("file" in stylesOrParams) {
        stylesOrParams.files = [stylesOrParams.file]
    }

    const {callback, files} = stylesOrParams

    return new Promise(resolve => {
        ready(function () {
            if (typeof files === "undefined") {
                injectRules(stylesOrParams)
                resolve()
            } else {
                injectStyleSheets(files, () => {
                    if (callback) {
                        callback()
                    }
                    resolve()
                })
            }

        })
    })

}



function injectStyleSheets (urls, callback) {
    let queue = createQueue(urls)

    urls.forEach(url => injectStyleSheet(url, callbackIfAllLoaded))

    function callbackIfAllLoaded (url) {
        delete queue[url]
        if (callback && Object.keys(queue).length === 0) {
            callback()
        }
    }
}


function createQueue (urls) {
    let queue = {}

    urls.forEach(url => {
        queue[url] = true
    })

    return queue
}


function injectStyleSheet (url, callback) {
    let {head} = document
    let link = document.createElement("link")

    link.type = "text/css"
    link.rel  = "stylesheet"
    link.href = url

    if (callback) {
        link.onload = function () {
            callback(url)
        }
    }

    head.appendChild(link)
}


function injectRules (styles) {

    let styleDom = document.createElement("style")
    styleDom.appendChild(document.createTextNode("")) //For some Safari versions
    document.head.appendChild(styleDom)

    let styleSheet = styleDom.sheet

    for (let selector in styles) {
        let content = styles[selector]
        let style = ""
        if (typeof content === "string") {
            style = content
        } else {
            for (let key in content) {
                style += `${key}: ${content[key]};`
            }
        }
        styleSheet.insertRule(`${selector} { ${style} }`, 0)
    }
}



function ready (callback) {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", callback)
    } else {
        callback()
    }
}



export default cssInjector

